<script lang="ts">
  import { SUBSCRIPTION_LIMITS, PRICING_PLANS } from '$lib/constants/subscription';

  // Import provider logos
  import openaiIcon from '$lib/../assets/ai-model-icons/openai.png';
  import claudeIcon from '$lib/../assets/ai-model-icons/claude.png';
  import googleIcon from '$lib/../assets/ai-model-icons/google.png';
  import openrouterIcon from '$lib/../assets/ai-model-icons/openrouter.png';
  import upstageIcon from '$lib/../assets/ai-model-icons/upstage.png';

  export let details: string = '';
</script>

<div class="prompt-content">
  {#if details === 'AI 분석은 프리미엄 기능입니다' || details === 'AI 분석 - 프리미엄 모델 선택'}
    <div class="ai-feature-header">
      <p class="upgrade-message">
        {#if details === 'AI 분석 - 프리미엄 모델 선택'}
          <strong>프리미엄 AI 모델</strong>을 사용하려면 업그레이드가 필요합니다
        {:else}
          <strong>AI 분석</strong>을 무제한으로 사용하려면 프리미엄으로 업그레이드하세요
        {/if}
      </p>
    </div>
    
    <div class="ai-features-comparison">
      <div class="feature-section unlimited">
        <div class="section-header">
          <span class="section-badge">무료 플랜</span>
          <h4 class="section-title">기본 AI 분석</h4>
        </div>
        <p class="section-description">
          하루 {SUBSCRIPTION_LIMITS.FREE.dailyAIAnalysisLimit}회 제한
        </p>
        <div class="model-list">
          <span class="model-chip limited">
            <img src={openrouterIcon} alt="OpenRouter" class="model-icon" />
            GPT OSS 120B
          </span>
          <span class="model-chip limited">
            <img src={openrouterIcon} alt="OpenRouter" class="model-icon" />
            Qwen2.5 32B
          </span>
        </div>
      </div>
      
      <div class="feature-divider"></div>
      
      <div class="feature-section custom">
        <div class="section-header">
          <span class="section-badge premium">프리미엄</span>
          <h4 class="section-title">무제한 AI 분석</h4>
        </div>
        
        <div class="premium-subsection">
          <p class="subsection-title">
            <span class="unlimited-badge">무제한</span>
            OpenRouter 모델
          </p>
          <div class="model-list">
            <span class="model-chip unlimited">
              <img src={openrouterIcon} alt="OpenRouter" class="model-icon" />
              GPT OSS 120B
            </span>
            <span class="model-chip unlimited">
              <img src={openrouterIcon} alt="OpenRouter" class="model-icon" />
              Qwen2.5 32B
            </span>
          </div>
        </div>
        
        <div class="premium-subsection">
          <p class="subsection-title">
            <span class="api-key-badge">API 키 필요</span>
            프리미엄 모델
          </p>
          <div class="provider-grid">
            <div class="provider">
              <img src={openaiIcon} alt="OpenAI" class="provider-icon" />
              <span>OpenAI GPT-4</span>
            </div>
            <div class="provider">
              <img src={claudeIcon} alt="Anthropic" class="provider-icon" />
              <span>Anthropic Claude</span>
            </div>
            <div class="provider">
              <img src={googleIcon} alt="Google" class="provider-icon" />
              <span>Google Gemini</span>
            </div>
            <div class="provider">
              <img src={upstageIcon} alt="Upstage" class="provider-icon" />
              <span>Upstage Solar</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="pricing-info">
      <span class="price-highlight">월 ${PRICING_PLANS.PREMIUM_MONTHLY.price}</span>
      <span class="price-divider">또는</span>
      <span class="price-annual">연 ${PRICING_PLANS.PREMIUM_YEARLY.price} <span class="save-badge">17% 할인</span></span>
    </div>
  {:else}
    <!-- General Feature Lock Design -->
    <div class="feature-locked-container">
      <div class="feature-locked-badge">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0110 0v4"></path>
        </svg>
        <span>프리미엄 기능</span>
      </div>
      
      <h4 class="feature-locked-title">이 기능을 사용하려면</h4>
      <p class="feature-locked-subtitle">프리미엄으로 업그레이드가 필요합니다</p>
      {#if details}
        <p class="feature-details-text">{details}</p>
      {/if}
    </div>
    
    <div class="plan-comparison-grid">
      <div class="plan-section free">
        <div class="plan-header">
          <span class="plan-badge">무료</span>
          <span class="plan-title">기본 기능</span>
        </div>
        <div class="feature-limits">
          <div class="limit-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
            <span>맞춤법 검사 하루 {SUBSCRIPTION_LIMITS.FREE.dailySpellCheckLimit}회</span>
          </div>
          <div class="limit-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
            <span>최대 {SUBSCRIPTION_LIMITS.FREE.maxTextLength}자 텍스트</span>
          </div>
          <div class="limit-item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="8" y1="12" x2="16" y2="12"></line>
            </svg>
            <span>AI 분석 하루 {SUBSCRIPTION_LIMITS.FREE.dailyAIAnalysisLimit}회</span>
          </div>
        </div>
      </div>
      
      <div class="plan-section premium">
        <div class="plan-header">
          <span class="plan-badge premium">프리미엄</span>
          <span class="plan-title">모든 기능 해제</span>
        </div>
        <div class="premium-features">
          <div class="feature-item">
            <span class="feature-icon">✓</span>
            <span>무제한 맞춤법 검사</span>
          </div>
          <div class="feature-item">
            <span class="feature-icon">✓</span>
            <span>최대 {SUBSCRIPTION_LIMITS.PREMIUM.maxTextLength.toLocaleString()}자 텍스트</span>
          </div>
          <div class="feature-item">
            <span class="feature-icon">✓</span>
            <span>무제한 AI 분석</span>
          </div>
          <div class="feature-item">
            <span class="feature-icon">✓</span>
            <span>모든 프리미엄 AI 모델</span>
          </div>
        </div>
      </div>
    </div>
  {/if}
</div>

<style>
  .prompt-content p {
    margin: 0 0 8px 0;
    color: var(--text-secondary);
    font-size: 13px;
    line-height: 1.5;
  }

  .ai-feature-header {
    margin-bottom: 20px;
  }

  .upgrade-message {
    font-size: 13px;
    color: var(--text-secondary);
    line-height: 1.6;
    margin: 0;
  }

  .upgrade-message strong {
    color: var(--text-primary);
    font-weight: 600;
  }

  .ai-features-comparison {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 20px;
    margin: 24px 0;
    padding: 20px;
    background: linear-gradient(to bottom, var(--bg-primary), var(--bg-secondary));
    border-radius: 12px;
    border: 1px solid var(--border-primary);
  }

  .feature-section {
    display: flex;
    flex-direction: column;
  }

  .section-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .section-badge {
    padding: 3px 8px;
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-radius: 12px;
    background: var(--success);
    color: white;
  }

  .section-badge.premium {
    background: linear-gradient(135deg, var(--accent-primary), var(--accent-secondary));
  }

  .section-title {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0;
  }

  .section-description {
    font-size: 11px;
    color: var(--text-secondary);
    line-height: 1.5;
    margin: 0 0 12px 0;
  }

  .model-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .model-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    font-size: 10px;
    font-weight: 500;
    background: var(--bg-primary);
    border: 1px solid var(--border-primary);
    border-radius: 6px;
    color: var(--text-primary);
  }
  
  .model-chip.limited {
    opacity: 0.7;
    border-color: var(--border-secondary);
  }
  
  .model-chip.unlimited {
    background: linear-gradient(135deg, rgba(16, 185, 129, 0.1), rgba(34, 197, 94, 0.1));
    border-color: rgba(16, 185, 129, 0.3);
    color: var(--success);
  }
  
  .model-icon {
    width: 12px;
    height: 12px;
    object-fit: contain;
  }
  
  :global(.dark) .model-icon {
    filter: invert(1) opacity(0.8);
  }

  .feature-divider {
    width: 1px;
    background: linear-gradient(to bottom, transparent, var(--border-primary), transparent);
    margin: 0 -10px;
  }

  .premium-subsection {
    margin-bottom: 16px;
  }
  
  .premium-subsection:last-child {
    margin-bottom: 0;
  }
  
  .subsection-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: var(--text-secondary);
    margin: 0 0 8px 0;
    font-weight: 500;
  }
  
  .unlimited-badge {
    display: inline-block;
    padding: 2px 6px;
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-radius: 10px;
    background: linear-gradient(135deg, #10b981, #22c55e);
    color: white;
  }
  
  .api-key-badge {
    display: inline-block;
    padding: 2px 6px;
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-radius: 10px;
    background: var(--bg-tertiary);
    color: var(--text-tertiary);
    border: 1px solid var(--border-secondary);
  }

  .provider-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
  }

  .provider {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 8px;
    font-size: 10px;
    font-weight: 500;
    background: var(--bg-primary);
    border: 1px solid var(--border-primary);
    border-radius: 6px;
    color: var(--text-primary);
    transition: all 0.15s;
  }

  .provider:hover {
    border-color: var(--accent-primary);
    color: var(--accent-primary);
    transform: translateY(-1px);
  }
  
  .provider-icon {
    width: 14px;
    height: 14px;
    object-fit: contain;
    flex-shrink: 0;
  }
  
  :global(.dark) .provider-icon {
    filter: invert(1) opacity(0.8);
  }

  .pricing-info {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 12px;
    background: linear-gradient(135deg, rgba(139, 92, 246, 0.05), rgba(139, 92, 246, 0.08));
    border: 1px solid rgba(139, 92, 246, 0.2);
    border-radius: 8px;
    margin-top: 16px;
  }

  .price-highlight {
    font-size: 16px;
    font-weight: 700;
    color: var(--accent-secondary);
  }

  .price-divider {
    font-size: 11px;
    color: var(--text-tertiary);
  }

  .price-annual {
    font-size: 14px;
    color: var(--text-secondary);
  }

  .save-badge {
    display: inline-block;
    padding: 2px 6px;
    font-size: 9px;
    font-weight: 600;
    background: var(--success);
    color: white;
    border-radius: 10px;
    margin-left: 4px;
    vertical-align: middle;
    position: relative;
    top: -1px;
  }

  /* General Feature Locked Styles */
  .feature-locked-container {
    text-align: center;
    margin-bottom: 20px;
  }

  .feature-locked-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: var(--bg-tertiary);
    border: 1px solid var(--border-primary);
    border-radius: 16px;
    margin-bottom: 12px;
  }

  .feature-locked-badge svg {
    width: 16px;
    height: 16px;
    color: var(--text-secondary);
  }

  .feature-locked-badge span {
    font-size: 11px;
    font-weight: 500;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .feature-locked-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 4px 0;
  }

  .feature-locked-subtitle {
    font-size: 14px;
    color: var(--text-secondary);
    margin: 0;
  }

  .feature-details-text {
    font-size: 13px;
    color: var(--text-tertiary);
    font-style: italic;
    margin: 8px 0 0 0;
  }

  .plan-comparison-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
    margin-bottom: 16px;
  }

  .plan-section {
    background: var(--bg-secondary);
    border: 1px solid var(--border-primary);
    border-radius: 12px;
    padding: 16px;
  }

  .plan-section.premium {
    background: linear-gradient(to bottom, rgba(139, 92, 246, 0.02), rgba(99, 102, 241, 0.02));
    border-color: var(--accent-border);
  }

  .plan-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
  }

  .plan-badge {
    padding: 2px 8px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-radius: 4px;
    background: var(--text-tertiary);
    color: white;
  }

  .plan-badge.premium {
    background: var(--accent-primary);
  }

  .plan-title {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
  }

  .feature-limits {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .limit-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: var(--text-primary);
    padding: 2px 0;
  }

  .limit-item svg {
    width: 16px;
    height: 16px;
    color: var(--text-tertiary);
    flex-shrink: 0;
  }

  .premium-features {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .feature-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: var(--text-primary);
    padding: 2px 0;
  }

  .feature-icon {
    color: var(--accent-primary);
    font-weight: 600;
    flex-shrink: 0;
  }
</style>